import { createContext } from 'react';

export interface VariablesConfig {
  allowSimpleVariables?: boolean;
  resolveVariablesToFallback?: boolean;
}
export const VariablesContext = createContext<VariablesConfig | null>(null);
